import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PortalToastrContainer from '../portal/portalToastrContainer';
import SettingsTabs from './settingsTabs';
import SettingsTabRoutes from './settingsTabRoutes';
import authorize from '../authorization/authorize';
import AccessDeniedBehavior from '../../services/enums/accessDeniedBehavior';
import Permissions from '../../services/enums/permissions';

@inject('routesStore') @observer
export default class Settings extends Component {

    render() {
        return(
            <div className='settings-wrapper'>
                <PortalToastrContainer />
                <SettingsTabs />
                <SettingsTabRoutes />
            </div>
        );
    }
}